import React, {useState, useEffect}from 'react';
import  { Handle,  } from 'reactflow';
import { FaTrash, FaPlus } from 'react-icons/fa';
import '../Node_Edge_Components.css';
import NodeIcons from './Node_Icons';

const Diamond = ({data, id}) => {
  const[nodeName, setNodeName] = useState(data.label);
  const [nodeColor, setNodeColor] = useState(data.color);
  const [nodeFontColor, setNodeFontColor] = useState(data.fontColor);
  const [nodeFontSize, setNodeFontSize] = useState(data.fontSize);
  const [nodeFontStyle, setNodeFontStyle] = useState(data.fontStyle);
  const [droppedIcon, setDroppedIcon] = useState(data.icon); // To hold the dropped icon
  const [droppedText, setDroppedText] = useState(data.label);
const [drop,setDrop ] = useState(false);
const [svgContent, setSvgContent] = useState('');
const [iconDisplay,setIconDisplay] = useState(false);
const [eventId,setEventId] = useState(null);
const [activeStatus,setActiveStatus] = useState(false);
const [assign,setAssign] = useState(data.assignTo);
const [eventDetails,setEventDetails] = useState(data.eventDetails);

useEffect(() => {
  setIconDisplay(data.showIcons || false);
}, [data.showIcons]);

  useEffect(() => {
    setNodeName(data.label);
    setNodeColor(data.color);
    setNodeFontColor(data.fontColor);
    setNodeFontSize(data.fontSize);  
    setNodeFontStyle(data.fontStyle);  
    setDroppedText(data.label);
  }, [data.label,data.color, data.fontColor, data.fontSize ,data.fontStyle]);

 useEffect(() => {
     if(drop && typeof data.updateNodeLabel === 'function'){
       console.log("event details on dropping",eventDetails);
       data.updateNodeLabel(id, droppedText,droppedIcon ,nodeColor, data.recData,data.permissionData,eventDetails,activeStatus,assign);
     }
        
   },  [droppedText]);

  useEffect(() => {
    if (droppedIcon) {
      fetch(droppedIcon)
        .then(response => response.text())
        .then(svg => {
          const coloredSvg = svg.replace(/fill="[^"]*"/g, `fill="#757EA5"`);
          setSvgContent(`data:image/svg+xml;base64,${btoa(coloredSvg)}`);
        })
        .catch(error => console.error(error));
    }
  }, [droppedIcon, ]);

  const handleDrop = (event) => {
    event.preventDefault();
    const imgSrc = event.dataTransfer.getData('imageSrc');
    const textValue = event.dataTransfer.getData('imageValueSrc');
    const eventDetails = event.dataTransfer.getData('eventDetails');
    const assign = event.dataTransfer.getData('assignTo');
    if (imgSrc) {
      let editEventDetails = eventDetails;
      if (typeof editEventDetails === "string") {
        editEventDetails = JSON.parse(editEventDetails);
       console.log("obj:", editEventDetails);
      }
      else{
        console.log("on drop inside rectangle",eventDetails);
      }
      setDroppedIcon(imgSrc);
      setDroppedText(textValue);
      setNodeName(textValue);
      setEventDetails(editEventDetails);
      setAssign(assign);
    setDrop(true);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const iconDisplayClose=()=>{
    setIconDisplay(false);
  }

  const handleStyles={
    background:'#757ea5',height:'0.5px',width:'0.5px',
      }

  return (
    <>
    <Handle type="target" position="top" className='handles'id={`${id}-top-target`} style={{ background:'#757ea5', height:'0.5px', width:'0.5px', left: '50%', transform: 'translateX(-50%)' }} />
   <Handle type="source" position="right" className='handles' id={`${id}-right-source`} style={handleStyles}/>
   <Handle type="target" position="left" className='handles' id={`${id}-left-target`} style={handleStyles}/>
   <Handle type="source" position="bottom" className='handles' id={`${id}-bottom-source`} style={handleStyles}/>

   <div className='outernode node'>
    <div className='border-diamond'>
    <div className='diamond node' onDrop={handleDrop}
      onDragOver={handleDragOver} >
     <div className='box-for-label-diamond' style={{ background:nodeColor}}>
     {droppedIcon == null && (
           <p className='normal-label' style={{ color: nodeFontColor,}}>{nodeName}</p>)}
         {droppedIcon !== null && (
           <div className='drag-drop-label-diamond'>
             <img src={svgContent} alt="icon" />
             <p style={{ color: nodeFontColor}}>{droppedText}</p>
           </div>
         )}
     </div>
      </div>
    </div>
   </div>

   {iconDisplay &&
      <NodeIcons 
      onDelete={() => data.onDelete(id)}
      onAdd={() => data.onAdd(id, "diamond")}
      handleCanvasClick={()=> data.handleCanvasClick("",2,false,[],false,0,eventDetails)}
     nodeIconsClose={iconDisplayClose}
      />
      }
   </>
  )
}

export default Diamond